import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import React, { useState } from "react";
import MailClient from "./mailclient";

function Enquiry({ className = "" }) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <style>{`
        /* ===== BUTTON (NEON + GRADIENT) ===== */
        .talk-to-us-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #00c6ff, #0072ff);
          color: #fff;
          border: none;
          font-weight: 600;
          padding: 10px 22px;
          border-radius: 50px;
          transition: all 0.3s ease;
          box-shadow: 0 0 10px rgba(0, 114, 255, 0.6);
          position: relative;
          overflow: hidden;
        }

        .talk-to-us-btn::before {
          content: "";
          position: absolute;
          width: 120%;
          height: 120%;
          background: radial-gradient(circle, rgba(255,255,255,0.3), transparent);
          top: -10%;
          left: -10%;
          opacity: 0;
          transition: opacity 0.3s;
        }

        .talk-to-us-btn:hover::before {
          opacity: 1;
        }

        .talk-to-us-btn:hover {
          transform: translateY(-2px) scale(1.03);
          box-shadow: 0 0 20px rgba(0, 114, 255, 0.9);
        }

        /* ===== MODAL BACKDROP ===== */
        .modal-backdrop.show {
          background: rgba(0, 0, 0, 0.7);
          backdrop-filter: blur(6px);
        }

        /* ===== MODAL CONTENT (GLASS EFFECT) ===== */
        .modal-content {
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(20px);
          border-radius: 16px;
          border: 1px solid rgba(255,255,255,0.2);
          box-shadow: 0 8px 32px rgba(0,0,0,0.3);
          color: #fff;
        }

        /* ===== HEADER ===== */
        .modal-header {
          border-bottom: 1px solid rgba(255,255,255,0.1);
        }

        .modal-title {
          font-weight: 600;
          letter-spacing: 0.5px;
        }

        /* ===== BODY ===== */
        .modal-body {
          padding: 25px;
        }

        /* ===== FOOTER ===== */
        .modal-footer {
          border-top: 1px solid rgba(255,255,255,0.1);
        }

        /* ===== CLOSE BUTTON ===== */
        .btn-close {
          filter: invert(1);
        }

        /* ===== CLOSE BUTTON STYLE ===== */
        .futuristic-close {
          background: linear-gradient(135deg, #ff416c, #ff4b2b);
          border: none;
          border-radius: 30px;
          padding: 8px 20px;
          color: white;
          font-weight: 500;
          transition: 0.3s;
        }

        .futuristic-close:hover {
          transform: scale(1.05);
          box-shadow: 0 0 12px rgba(255,75,43,0.7);
        }
      `}</style>

      {/* BUTTON */}
      <Button
        className={`talk-to-us-btn ${className}`.trim()}
        onClick={handleShow}
      >
        🚀 Talk to Us
      </Button>

      {/* MODAL */}
      <Modal show={show} onHide={handleClose} centered animation>
        <Modal.Header closeButton>
          <Modal.Title>✨ Callback Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <MailClient />
        </Modal.Body>

        <Modal.Footer>
          <button className="futuristic-close" onClick={handleClose}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Enquiry;